import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appEcommerce from './app-ecommerce'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    app,
    appConfig,
    appEcommerce,
    verticalMenu,
  },
  strict: process.env.DEV,
})
